import { defineMessages } from 'react-intl';

export default defineMessages({
    mr: {
        id: '_.name_field.mr',
        defaultMessage: 'Mr'
    },
    mrs: {
        id: '_.name_field.mrs',
        defaultMessage: 'Mrs'
    },
    ms: {
        id: '_.name_field.ms',
        defaultMessage: 'Ms'
    },
    miss: {
        id: '_.name_field.miss',
        defaultMessage: 'Miss'
    },
    doctor: {
        id: '_.name_field.doctor',
        defaultMessage: 'Doctor'
    },
    professor: {
        id: '_.name_field.professor',
        defaultMessage: 'Professor'
    },
    sir: {
        id: '_.name_field.sir',
        defaultMessage: 'Sir'
    },
    lord: {
        id: '_.name_field.lord',
        defaultMessage: 'Lord'
    },
    lady: {
        id: '_.name_field.lady',
        defaultMessage: 'Lady'
    },
    baron: {
        id: '_.name_field.baron',
        defaultMessage: 'Baron'
    },
    baroness: {
        id: '_.name_field.baroness',
        defaultMessage: 'Baroness'
    },
    rev: {
        id: '_.name_field.reverend',
        defaultMessage: 'Reverend'
    }
});
